import { Grid, Tooltip, Typography } from "@material-ui/core";
import React from "react";
import "./gridControls.scss";

const GridLabel = (props) => {
  return (
    <div className="grid-container">
      <Tooltip title={props.value} arrow placement="right-start" >
        <Typography
          className="grid-label"
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {props.value}
        </Typography>
      </Tooltip>
    </div>
  );
};

export default GridLabel;
